import Reveal from "@/components/Reveal";

const DATES = [
  { label: "Application Opens", date: "2 November 2026" },
  { label: "Application Closes", date: "29 November 2026" },
  { label: "Notification of Acceptance", date: "21–30 December 2026" },
  { label: "Event Day", date: "30 January 2027", highlight: true },
];

export default function ImportantDates() {
  return (
    <div className="dates-wrap" data-testid="important-dates">
      <Reveal>
        <div className="kicker">Important dates</div>
        <h2 className="title dates-title">Mark your calendar.</h2>
      </Reveal>
      <div className="dates">
        {DATES.map((d, i) => (
          <Reveal
            key={d.label}
            delay={i * 0.08}
            className={`date-card ${d.highlight ? "date-card-hl" : ""}`}
            data-testid="date-card"
          >
            <span className="date-label">{d.label}</span>
            <span className="date-value">{d.date}</span>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
